var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title ljb-big-title flex ljb-double_center"},[_vm._v("\n  "+_vm._s(_vm.moduleTitle.title)+"\n  "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.moduleTitle.text),expression:"moduleTitle.text"}],staticClass:"text"},[_vm._v(_vm._s(_vm.moduleTitle.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-30f313b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/title/ModuleTitle.vue
// module id = null
// module chunks = 